import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, MutationIntentProjectUnlockArgs } from "types/generated";

export const INTENT_PROJECT_UNLOCK: TypedDocumentNode<
  { intentProjectUnlock: IntentProject },
  MutationIntentProjectUnlockArgs
> = gql`
  mutation IntentProjectUnlock($id: ID!) {
    intentProjectUnlock(id: $id) {
      id
      name
      lockedBy
    }
  }
`;
